let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hPuYk")).then(() => parcelRequire('rxPon'));